import { useMutateEntry } from '@utils/component-framework';
import { bringItemToFront } from './utils/bring-item-to-front.js';
import { getItemEntryById } from './utils/get-item-by-id.js';
import { getPageEntryById } from './utils/get-page-by-id.js';

function useCreateCloneEntryMutation(entryKey) {
  const mutater = useMutateEntry(entryKey);
  return args => mutater(entry => {
    const page = getPageEntryById(entry.data, args.pageId);
    const item = getItemEntryById(page, args.itemId);
    const cloneEntry = {
      zIndex: 0,
      position: args.position,
      itemId: args.itemId,
      cloneId: args.cloneId,
      entry: item.entry
    };
    page.clones.push(cloneEntry);
    bringItemToFront(page, cloneEntry);
    return entry;
  });
}

export { useCreateCloneEntryMutation };
//# sourceMappingURL=clone.create.js.map
